// extracted by mini-css-extract-plugin
module.exports = {"header":"EquipmentShowContainer_header__WML9T"};